import type { PlanForm } from '@components/empresas/PlanesLista';
import type { AltaPlanPayload } from '@lib/services/empresas.service';

/**
 * Del plan como está en el formulario del ABM al plan como lo espera el
 * server. Es UN solo lugar a propósito: el alta (`Empresas.tsx`) y el detalle
 * (`EmpresaDetalle.tsx`) armaban el mismo map cada uno por su lado y el switch
 * "en venta" quedó afuera de los dos: el admin lo destildaba, guardaba, y al
 * recargar volvía tildado (auditoría 17/09/2026).
 *
 * `disponibleVenta` viaja solo cuando está apagado: la semántica del server es
 * "sin flag = en venta", así la config de una empresa que nunca lo tocó no se
 * ensucia con `true` explícitos.
 */
export function planesAPayload(planes: PlanForm[]): AltaPlanPayload[] {
  return planes
    .filter((p) => p.codigo.trim())
    .map((p) => ({
      codigo: p.codigo.trim(),
      nombre: p.nombre || undefined,
      sucursalId: p.sucursalId || undefined,
      categoriaAfiliadoCodigo: p.categoriaAfiliadoCodigo || undefined,
      aaCodigo: p.aaCodigo || undefined,
      aa2Codigo: p.aa2Codigo || undefined,
      esBase: p.esBase,
      ...(p.disponibleVenta === false ? { disponibleVenta: false } : {}),
    }));
}
